import { accountUpdateTemplate } from "./accountUpdate";
import { generalAnnouncementTemplate } from "./generalAnnouncement";
import { promotionTemplate } from "./promotion";
import { safetyAlertTemplate } from "./safetyAlert";
import { serviceUpdateTemplate } from "./serviceUpdate";

import type {
    AdminAnnouncementEmailTemplateDefinition,
    AdminAnnouncementEmailTemplateKey,
} from "./types";

export type {
    AdminAnnouncementEmailPreviewSection,
    AdminAnnouncementEmailTemplateContext,
    AdminAnnouncementEmailTemplateDefinition,
    AdminAnnouncementEmailTemplateField,
    AdminAnnouncementEmailTemplateKey,
} from "./types";

export const DEFAULT_ADMIN_ANNOUNCEMENT_EMAIL_TEMPLATE: AdminAnnouncementEmailTemplateKey =
    "GENERAL_ANNOUNCEMENT";

export const ADMIN_ANNOUNCEMENT_EMAIL_TEMPLATES: Record<
    AdminAnnouncementEmailTemplateKey,
    AdminAnnouncementEmailTemplateDefinition
> = {
    GENERAL_ANNOUNCEMENT: generalAnnouncementTemplate,
    SERVICE_UPDATE: serviceUpdateTemplate,
    PROMOTION: promotionTemplate,
    SAFETY_ALERT: safetyAlertTemplate,
    ACCOUNT_UPDATE: accountUpdateTemplate,
};

export const ADMIN_ANNOUNCEMENT_EMAIL_TEMPLATE_OPTIONS = Object.values(
    ADMIN_ANNOUNCEMENT_EMAIL_TEMPLATES
).map(({ key, label, description }) => ({
    value: key,
    label,
    description,
}));

export const createInitialAnnouncementTemplateDrafts = () =>
    Object.keys(ADMIN_ANNOUNCEMENT_EMAIL_TEMPLATES).reduce(
        (drafts, key) => ({
            ...drafts,
            [key]: {},
        }),
        {} as Record<AdminAnnouncementEmailTemplateKey, Record<string, string>>
    );
